<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh
                            v-if="fe_part_category.category_id && fe_part_category.category_id > 0"
                            @invoke-method="dbGetFePartCategory(true)"
                        ></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="fe_part_category.category_id && fe_part_category.category_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('fe_part_categories.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in fe_part_category_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != fe_part_category.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('fe_part_categories.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_fe_part_category.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'fe_part_categories' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="fe_part_category.status" class="ribbon ribbon-top-right" :class="`ribbon-${fe_part_category.status_class}`">
                            <span class="ribbon-span">{{ fe_part_category.status }}</span>
                        </div>
                        <v-form ref="formFePartCategory">
                            <v-flex xs12>
                                <v-text-field
                                    v-focus="fe_part_category_dialog"
                                    v-model="fe_part_category.category_id"
                                    :label="`${$t('lang.category_id')} *`"
                                    :counter="showCounter(fe_part_category.category_id, 'fe_part_categories.category_id')"
                                    :rules="ifValid('fe_part_categories.category_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="fe_part_category.category_name"
                                    :label="$t('lang.category_name')"
                                    :counter="showCounter(fe_part_category.category_name, 'fe_part_categories.category_name')"
                                    :rules="ifValid('fe_part_categories.category_name')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                    v-model="fe_part_category.category_description"
                                    :label="$t('lang.category_description')"
                                    auto-grow
                                    rows="1"
                                    :rules="ifValid('fe_part_categories.category_description')"
                                ></v-textarea>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'fe_part_categories' })" flat>{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="saveFePartCategories">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_fe_part_category"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_fe_part_category')"
                :message="$t('lang.delete_fe_part_category_confirm')"
                @onConfirm="deleteFePartCategories()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_fe_part_category_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteFePartCategoryDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            fe_part_category: {},
            file_name: "",
            dbGetFePartCategory: _.debounce(this.getFePartCategory, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchFePartCategory", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.fe_part_category) {
                        this.fe_part_category = this.assignObj2(data.fe_part_category, this.rules_fe_part_categories);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=fe_part_category_status&sort_by=2",
                            method: "get",
                            stateProperty: "fe_part_category_status_options",
                            dataProperty: "options",
                            commit: true,
                        });
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "fe_part_categories", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchFePartCategory", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.fe_part_category) {
                        next((vm) => {
                            vm.fe_part_category = vm.assignObj2(data.fe_part_category, vm.rules_fe_part_categories);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=fe_part_category_status&sort_by=2",
                                method: "get",
                                stateProperty: "fe_part_category_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "fe_part_categories", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=fe_part_category_status&sort_by=2",
            method: "get",
            stateProperty: "fe_part_category_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_fe_part_categories: (state) => state.fe_part_categories.rules_fe_part_categories,
            fe_part_category_status_options: (state) => state.settings.fe_part_category_status_options,
            fe_part_categories: (state) => state.fe_part_categories.fe_part_categories,
            selectedFePartCategory: (state) => state.fe_part_categories.selectedFePartCategory,
        }),
    },
    methods: {
        ...mapActions(["fetchFePartCategory", "saveFePartCategory", "deleteFePartCategory", "printFePartCategory"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getFePartCategory(pg_refresh = false) {
            this.startLoader();

            this.fetchFePartCategory({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.fe_part_category) {
                    this.fe_part_category = this.assignObj2(data.fe_part_category, this.rules_fe_part_categories);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printFePartCategory({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.fe_part_category) {
                    if (this.dev_mode) {
                        this.file_name = data.fe_part_category.file_name;
                    } else {
                        this.$refs.print.printReport(data.fe_part_category.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveFePartCategories() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formFePartCategory")) {
                    let body = this.prepForm(this.fe_part_category, this.rules_fe_part_categories);

                    this.saveFePartCategory({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.fe_part_category) {
                            this.$router.push({ name: "fe_part_category", params: { id: data.fe_part_category.category_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { category_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveFePartCategories({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.fe_part_category) {
                    this.fe_part_category = this.assignObj2(data.fe_part_category, this.rules_fe_part_categories);
                }
            });
        },
        deleteFePartCategories() {
            this.deleteFePartCategory({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "fe_part_categories" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchFePartCategory({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.fe_part_category) {
                        this.fe_part_category = this.assignObj2(data.fe_part_category, this.rules_fe_part_categories);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }
        },
    },
    created() {},
};
</script>
